var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getBusinessPermission || _vm.userType == "super_admin"
    ? _c("div", { staticClass: "setting-main-container" }, [
        _c("div", { staticClass: "card setting-card" }, [
          _c("div", { staticClass: "page-header" }, [
            _c("h3", { staticClass: "page-title" }, [
              _vm._v(_vm._s(_vm.$t("profile.business_nature.business_nature"))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-12 mb-4 form-group" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(
                  _vm._s(
                    _vm.$tc(
                      "profile.borrowerProfile.businessDetails.business_name"
                    )
                  )
                ),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _vm.business && _vm.business.name != null
                ? _c("p", [_vm._v(_vm._s(_vm.business.name))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12 mb-4 form-group" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(
                  _vm._s(
                    _vm.$tc("profile.borrowerProfile.businessDetails.address")
                  )
                ),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _vm.business && _vm.business.address != null
                ? _c("p", [_vm._v(_vm._s(_vm.business.address))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-12 mb-4 form-group" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(
                  _vm._s(
                    _vm.$tc(
                      "profile.borrowerProfile.businessDetails.business_phone"
                    )
                  )
                ),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _vm.business && _vm.business.phone != null
                ? _c("p", [_vm._v(_vm._s(_vm.business.phone))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-4 form-group" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(
                  _vm._s(
                    _vm.$tc(
                      "profile.borrowerProfile.businessDetails.sales_tax_num"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _vm.business && _vm.business.sale_tax != null
                ? _c("p", [_vm._v(_vm._s(_vm.business.sale_tax))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-4 form-group" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(
                  _vm._s(
                    _vm.$tc("profile.borrowerProfile.businessDetails.email")
                  )
                ),
              ]),
              _vm._v(" "),
              _vm.business && _vm.business.email != null
                ? _c("p", [_vm._v(_vm._s(_vm.business.email))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-4 form-group" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(
                  _vm._s(
                    _vm.$tc(
                      "profile.borrowerProfile.businessDetails.importing_registration"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _vm.business && _vm.business.importing_registration != null
                ? _c("p", [_vm._v(_vm._s(_vm.business.importing_registration))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-4 form-group" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(
                  _vm._s(
                    _vm.$tc(
                      "profile.borrowerProfile.businessDetails.exporting_registration"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _vm.business && _vm.business.exporting_registration != null
                ? _c("p", [_vm._v(_vm._s(_vm.business.exporting_registration))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-4 form-group" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(
                  _vm._s(
                    _vm.$tc(
                      "profile.borrowerProfile.businessDetails.date_establishment"
                    )
                  )
                ),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _vm.business && _vm.business.date_establishment != null
                ? _c("p", [_vm._v(_vm._s(this.business.date_establishment))])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-md-6 mb-4 form-group" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(
                  _vm._s(
                    _vm.$tc(
                      "profile.borrowerProfile.businessDetails.date_opening_ac"
                    )
                  )
                ),
              ]),
              _c("span", { staticClass: "text-danger" }, [_vm._v(" * ")]),
              _vm._v(" "),
              _vm.business && _vm.business.date_openingAc != null
                ? _c("p", [_vm._v(_vm._s(this.business.date_openingAc))])
                : _vm._e(),
            ]),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }